import type { ReactNode } from 'react';

interface Props {
  selectedCount: number;
  onDeselectAll: () => void;
  itemLabel?: string;
  children: ReactNode;
}

export function BulkSidebarShell({
  selectedCount,
  onDeselectAll,
  itemLabel = 'Document',
  children,
}: Props) {
  const plural = selectedCount === 1 ? '' : 's';
  return (
    <div className="lg:col-span-4">
      <div className="sticky top-0">
        <div className="flex items-center justify-between mb-4 px-4 py-2">
          <button
            onClick={onDeselectAll}
            className="inline-flex items-center justify-start text-sm font-medium focus:outline-none dark:focus:outline-none dark:focus:ring-2 dark:focus:ring-offset-2 dark:focus:ring-blue-500 text-blue-500 hover:text-blue-700 underline"
          >
            Deselect All
          </button>
          <div className="text-sm text-gray-500 dark:text-zinc-400">
            {selectedCount} Selected {itemLabel}
            {plural}
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}
